import { useCallback, useState } from 'react';
import {
  useGetUserMeQuery,
  useUpdateUserMutation,
} from '../../impl/blfApi/endpoints/users';
import { defaultUserSettings, useSettings } from './useSettings';

export const usePreferredLanguage = (): {
  preferredLanguage: string | undefined;
  setPreferredLanguage: (newLanguage: string) => void;
  isUpdating: boolean;
} => {
  const [isLoading, setIsLoading] = useState(false);
  const { data: user } = useGetUserMeQuery();

  const { settings, isSettingsLoading } = useSettings();

  const [updateUser] = useUpdateUserMutation();

  const setPreferredLanguage = useCallback(
    async (newLanguage: string) => {
      if (user?.id && !isSettingsLoading) {
        try {
          setIsLoading(true);
          await updateUser({
            id: user.id,
            settings: {
              ...(settings || defaultUserSettings),
              language: newLanguage,
            },
          }).unwrap();
        } catch (error) {
          console.error(error);
          throw new Error('Failed to update preferred language');
        } finally {
          setIsLoading(false);
        }
      }
    },
    [user?.id, settings, updateUser, isSettingsLoading]
  );

  return {
    preferredLanguage: settings?.language,
    setPreferredLanguage,
    isUpdating: isLoading,
  };
};
